import { render, staticRenderFns } from "./BaseLeftMenuTraiPhang.vue?vue&type=template&id=5868b2e4&scoped=true&"
import script from "./BaseLeftMenuTraiPhang.vue?vue&type=script&lang=js&"
export * from "./BaseLeftMenuTraiPhang.vue?vue&type=script&lang=js&"
import style0 from "./BaseLeftMenuTraiPhang.vue?vue&type=style&index=0&id=5868b2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5868b2e4",
  null
  
)

export default component.exports